import { axios } from '@/lib/axios';

import { AuthUser, UserPermission } from '../types';

export function getUser(withPermission: true): Promise<UserPermission>;
export function getUser(withPermission?: false): Promise<AuthUser>;
export function getUser(
  withPermission?: boolean
): Promise<AuthUser | UserPermission> {
  if (withPermission) {
    return axios.get('/api/v1/auth/sessions', { params: { withPermission } });
  } else {
    return axios.get('/api/v1/auth/sessions');
  }
}

export const getUserPermission = (): Promise<UserPermission> => {
  return getUser(true) as Promise<UserPermission>;
};
